import { storeCreator } from '@/utils/store/store.utils';

interface State {
  nextScheduledTime?: string;
  handleSetNextScheduledTime: (value?: string) => void;
}

export const useStore = storeCreator<State>((set) => ({
  nextScheduledTime: undefined,

  handleSetNextScheduledTime: (value) => set((state) => ({
    ...state,
    nextScheduledTime: value,
  })),
}));
